export default __webpack_public_path__ + "static/media/Group.873e5c97.png";